<template>
<div :style="dendrogramStyle" @mousedown="startDrag" @mousemove="doDrag" @mouseup="stopDrag">
  <div class="box-head" >
    Residues clustered by ACI
  </div>

  <div style="padding:10px 0px">
    <a :href="$store.state.host+`/dokhlab/actions/ohm/result?id=${task.id}&file=dendrogram-normal`">{{task.id}}-dendrogram-normal.png</a>
  </div>

  <div v-if="!showPlot">
    <el-button @click.native="showPlot=true" type="text">View Dendrogram</el-button>
  </div>

  <div v-if="showPlot" ref="correlationContainer" style="position:relative;width:100%">
    <img style="width:100%;height:100%;object-fit:contain" :src="imgLink">
  </div>
</div>
</template>

<script>
// import interpolate from 'color-interpolate'
// import Chart from 'chart.js'
// import 'chartjs-chart-matrix'
import { saveAs } from 'file-saver'
// import * as d3 from 'd3'
// import axios from 'axios'
import { saveSvgAsPng } from 'save-svg-as-png'

export default {
  name: 'Dendrogram',

  data () {
    return {
      showPlot: false,
      active_site: [],
      allosteric_site: [],
      dendrogramStyle: {
//        border: '1px solid #eeeeee',
        margin: '20px 0px',
        position: 'relative',
        '-webkit-user-select': 'none',
        '-moz-user-select': 'none',
        '-khtml-user-select': 'none',
        '-ms-user-select': 'none'
      },
      correlationMatrixStyle: {
        fontSize: '10px',
        fontFamily: 'sans-serif',
        marginLeft: '80px',
        cursor: 'default'
      },
      dragging: false,
      oldMousePosition: [],
    }
  },

  props: [ 'value' ],

  computed: {
    task () {
      return this.$store.state.task
    },

    imgLink () {
      return `${this.$store.state.host}/dokhlab/actions/ohm/result?id=${this.task.id}&file=dendrogram-normal`
    }
  },

  methods: {
    downloadPng () {
//      console.log(saveSvgAsPng)
      saveSvgAsPng(document.getElementById('correlation-matrix-svg'), 'correlation-matrix.png')
    },

    startDrag () {
      this.dragging = true
      this.correlationMatrixStyle.cursor = 'pointer'
    },

    doDrag (e) {
      let v = this
      if (this.oldMousePosition) {
        var dx = e.clientX - this.oldMousePosition[0]
        var dy = e.clientY - this.oldMousePosition[1]
        if (this.dragging) {
          v.$refs.correlationContainer.scrollLeft -= dx
          v.$refs.correlationContainer.scrollTop -= dy
        }
      }
      this.oldMousePosition = [e.clientX, e.clientY]
    },

    stopDrag () {
      this.dragging = false
      this.correlationMatrixStyle.cursor = 'default'
    },

    download () {
      this.cyPromise.then(cy => {
        saveAs(cy.png({'output': 'blob'}), 'nodes.png')
      })
    },

    redirect (url) {
      window.location.href = url
    },

    openNewTab (url) {
      window.open(url, '_blank')
    },

    getInd (chainName, resNum) {
      for (let i of this.task.results.ind) {
        //        console.log(JSON.stringify(i))
        //        console.log(`${chainName}/${resNum}`)
        if (`${chainName}/${resNum}` === i.name) {
          return i.num
        }
      }
      return -1
      //      return this.task.results.ind.find(i => i.name === `${chainName}/${resNum}`).num
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.box-head {
  padding: 10px;
  border-bottom: 1px solid #eeeeee;
  background-color: $theme-color;
  font-weight: 700;
  color: white;
}
</style>
